/* Diwali 2026 - header menu. The store's visible menu (desktop bar + phone drawer) is drawn by the Qikify Smart Menu
   app from the config it prints into every page (<script id="qikify-smartmenu-config"> -> window._SM.newEntries).
   That config can only be edited inside the app, so this file, which runs BEFORE the app's deferred smartmenu-v2.js
   (defer scripts run in document order; this one is in <head>), points the "Gift Hampers" item at the Diwali Hampers
   page and renames it. Owner 2026-10-13: "in the menu on the website, change link from gifting hampers to diwali hampers".
   Remove this file + its <script> line in layout/theme.liquid after Diwali, or once the item is changed inside
   Apps > Smart Menu (then nothing matches and this does nothing). Source: D:\projects\1970_Shop\105_Diwali_Hampers_Nav_Search */
(function () {
  var FROM_HANDLE = 'gifting-hampers';
  var TO_PAGE = { id: 'gid://shopify/Page/138255171802', title: 'Diwali Hampers', handle: 'diwali-hampers' };
  var FROM_LABEL = 'Gift Hampers', TO_LABEL = 'Diwali Hampers';
  function walk(o) {
    if (!o || typeof o !== 'object') return 0;
    var n = 0, k;
    if (Object.prototype.toString.call(o) === '[object Array]') { for (k = 0; k < o.length; k++) n += walk(o[k]); return n; }
    var s = o.setting;
    if (s && s.url && s.url.page && s.url.page.handle === FROM_HANDLE) {
      s.url.page = { id: TO_PAGE.id, title: TO_PAGE.title, handle: TO_PAGE.handle };
      if (s.title === FROM_LABEL) s.title = TO_LABEL;
      n++;
    }
    for (k in o) if (Object.prototype.hasOwnProperty.call(o, k) && k !== 'setting') n += walk(o[k]);
    return n;
  }
  try {
    if (window._SM && window._SM.newEntries) window.__diwaliNav = walk(window._SM.newEntries);
  } catch (e) {}
})();
